export const switchBoolean = (value) => [true, 1, "1", "true"].includes(value);
export function categorizeSwitchResponse(value) {
  if (!value || typeof value !== "string") return "default";
  const response = value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
  if (/sin alcance|no carga la app|connection refused|timeout/.test(response)) return "error";
  if (
    /no se realiza reinicio|puerto sin consumo|puerto desactivado|no aparece el boton/.test(
      response
    )
  )
    return "warning";
  if (/se realizo correctamente el (?:re)?inicio|reinicio exitoso/.test(response)) return "success";
  if (/con alcance|se puede hacer clic|puerto activo/.test(response)) return "info";
  return "default";
}
export function switchDate(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return "Sin registro";
  return new Date(value).toLocaleString("es-CO", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}
const latestAttempt = (ports) =>
  ports.reduce(
    (last, port) =>
      Number.isFinite(Date.parse(port.resetdate)) &&
      (!last || Date.parse(port.resetdate) > Date.parse(last))
        ? port.resetdate
        : last,
    null
  );
export function mapSwitchGroups(data) {
  return data
    .filter((group) => group && Array.isArray(group.elements))
    .map((group) => {
      const ports = group.elements
        .filter((port) => port && typeof port === "object")
        .map((port) => ({
          ...port,
          id: port.id ?? port.idswitchport,
          portId: port.idswitchport ?? port.id,
          nameswitch: port.nameswitch || group.nameswitch,
          ipswitch: port.ipswitch || group.ipswitch,
          port: port.port ?? "Sin número",
          software: port.software || "Versión no disponible",
          hardware: port.hardware ?? group.hardware,
          resetstatus: switchBoolean(port.resetstatus),
          resetresponse: port.resetresponse || "Sin respuesta registrada",
          respuestaColor: categorizeSwitchResponse(port.resetresponse),
        }))
        .sort((a, b) => Number(a.port) - Number(b.port));
      return {
        id: String(ports[0]?.idswitch ?? `${group.ipswitch}|${group.nameswitch}`),
        idswitch: ports[0]?.idswitch ?? null,
        name: String(group.nameswitch || "Switch sin nombre").trim(),
        ip: group.ipswitch || "Sin dirección IP",
        hardware: group.hardware ?? "Sin dato",
        version: ports[0]?.software || "Versión no disponible",
        totalPorts: ports.length,
        activePorts: ports.filter((p) => p.resetstatus).length,
        ports,
        lastReset: latestAttempt(ports),
      };
    });
}
export function switchStats(groups) {
  const ports = groups.flatMap((g) => g.ports),
    active = ports.filter((p) => p.resetstatus).length;
  const count = (type) => ports.filter((p) => p.respuestaColor === type).length;
  return {
    totalGroups: groups.length,
    totalPorts: ports.length,
    activePorts: active,
    inactivePorts: ports.length - active,
    success: count("success"),
    error: count("error"),
    warning: count("warning"),
    info: count("info"),
    unknown: count("default"),
    lastReset: latestAttempt(ports),
  };
}
// Only a newer timestamp for a requested port can confirm this operation.
export function assessSwitchAttempts(before, after, requestedIds, startedAt) {
  const previous = new Map(before.flatMap((g) => g.ports).map((p) => [String(p.portId), p]));
  const current = new Map(after.flatMap((g) => g.ports).map((p) => [String(p.portId), p]));
  const result = { success: 0, error: 0, warning: 0, unconfirmed: 0 };
  requestedIds.forEach((id) => {
    const old = previous.get(String(id)),
      port = current.get(String(id));
    const date = Date.parse(port?.resetdate),
      oldDate = Date.parse(old?.resetdate);
    if (
      !port ||
      !Number.isFinite(date) ||
      (Number.isFinite(oldDate) && date <= oldDate) ||
      date < startedAt - 5000
    )
      result.unconfirmed++;
    else if (["success", "error", "warning"].includes(port.respuestaColor))
      result[port.respuestaColor]++;
    else result.unconfirmed++;
  });
  return result;
}
